module.exports = __webpack_public_path__ + "img/low.154f4828.svg";